angular.module("app")
	.directive("okinaMapControlOverlays", [
		"OkinaLeafletService", "CartoService", "toastr", "$timeout",
		function (OkinaLeafletService, CartoService, toastr, $timeout) {
			"use strict";

		return {
			restrict: "E",
			templateUrl: "common/directives/geoloc/okinaMapControls/overlays/okinaMapControlOverlays.html",
			link: function ($scope) {

				$scope.overlays = OkinaLeafletService.directiveProperties.overlays;


				/**
					 * Affiche ou masque un overlay
					 * @param overlay
					 */
				$scope.toggleOverlay = function (overlay) {
					if (!overlay.display) {
						OkinaLeafletService.hideOverlay(overlay.layer);
					} else {
						OkinaLeafletService.showOverlay(overlay.layer);

						switch (overlay.type) {
						}
					}
				};

				for (var overlayKey in $scope.overlays) {
					if ($scope.overlays[overlayKey].display) {
						$scope.toggleOverlay($scope.overlays[overlayKey]);
					}
				}

				// Link Watchers and init Display for Institutions
				$scope.$watch("overlays.institutions.display", function (newValue, oldValue) {
					if (newValue !== oldValue) {
						$scope.toggleOverlay($scope.overlays.institutions);
					}
				});

			}
		};
	}]
	);
